import React from 'react';

const CHECKOUT_URL = 'https://keyfutureskills.gumroad.com/l/oimlrx?wanted=true';

function CTA({ note }) {
  return (
    <div className="cta-wrap">
      <a className="cta-button" href={CHECKOUT_URL}>
        Get the folder — $45
        <span aria-hidden="true">→</span>
      </a>
      {note && <p className="cta-note">{note}</p>}
    </div>
  );
}

export default CTA;